import { ThemeName } from "@/styles/Theme";

export const ORG_BILDTVAPP = "BILDTVAPP";
export const DEFAULT_BRAND_SETTINGS: BrandSettings = {
  id: "default",
  themeName: ThemeName.default,
  locale: "de_de",
};

export type BrandSettings = {
  id: string;
  locale: string;
  themeName: ThemeName;
};

export type Organization = BrandSettings & {
  categories?: BrandSettings[];
};

export const organizations: Organization[] = [
  {
    id: "WELT",
    themeName: ThemeName.welt,
    categories: [
      {
        id: "icon",
        themeName: ThemeName.icon,
        locale: "de_de",
      },
    ],
    locale: "de_de",
  },
  { id: "BILD", themeName: ThemeName.bild, locale: "de_de" },
  {
    id: "BILD-BOOKS",
    themeName: ThemeName.default,
    locale: "de_de",

    categories: [
      {
        id: "travelbook",
        themeName: ThemeName.bild_travelbook,
        locale: "de_de",
      },
      {
        id: "fitbook",
        themeName: ThemeName.bild_fitbook,
        locale: "de_de",
      },
      {
        id: "stylebook",
        themeName: ThemeName.bild_stylebook,
        locale: "de_de",
      },
      {
        id: "techbook",
        themeName: ThemeName.bild_techbook,
        locale: "de_de",
      },
      {
        id: "myhomebook",
        themeName: ThemeName.bild_myhomebook,
        locale: "de_de",
      },
    ],
  },
  {
    id: "AUBI",
    themeName: ThemeName.aubi,
    locale: "de_de",
  },
  {
    id: "COBI",
    themeName: ThemeName.cobi,
    locale: "de_de",
  },
  {
    id: "SPOBI",
    themeName: ThemeName.spobi,
    locale: "de_de",
  },
  { id: "BZ", themeName: ThemeName.bild, locale: "de_de" },
  {
    id: "BRANDSTUDIO",
    themeName: ThemeName.default,
    locale: "de_de",
    categories: [
      {
        id: "bild-brand",
        themeName: ThemeName.bild_brandstory,
        locale: "de_de",
      },
      {
        id: "bild-product-advertorial",
        themeName: ThemeName.bild_productstory,
        locale: "de_de",
      },
      {
        id: "books-travelbook-brand",
        themeName: ThemeName.bild_travelbook,
        locale: "de_de",
      },
      {
        id: "books-fitbook-brand",
        themeName: ThemeName.bild_fitbook,
        locale: "de_de",
      },
      {
        id: "books-stylebook-brand",
        themeName: ThemeName.bild_stylebook,
        locale: "de_de",
      },
      {
        id: "books-techbook-brand",
        themeName: ThemeName.bild_techbook,
        locale: "de_de",
      },
      {
        id: "books-myHomebook-brand",
        themeName: ThemeName.bild_myhomebook,
        locale: "de_de",
      },
      {
        id: "welt-brand",
        themeName: ThemeName.welt_brandstory,
        locale: "de_de",
      },
      {
        id: "welt-product-advertorial",
        themeName: ThemeName.welt_productstory,
        locale: "de_de",
      },
    ],
  },
  {
    id: "MEDIAPIONEER",
    themeName: ThemeName.mediapioneer,
    locale: "de_de",
  },
  {
    id: "MUSIKEXPRESS",
    themeName: ThemeName.musikexpress,
    locale: "de_de",
  },
  {
    id: ORG_BILDTVAPP,
    themeName: ThemeName.bild,
    locale: "de_de",
  },
  {
    id: "ROLLINGSTONE",
    themeName: ThemeName.rollingstone,
    locale: "de_de",
  },
  {
    id: "METALHAMMER",
    themeName: ThemeName.metalhammer,
    locale: "de_de",
  },
  {
    id: "RINGIERAXELSPRINGER",
    themeName: ThemeName.default,
    locale: "pl_pl",
  },
  {
    id: "WELT_CONTRAST",
    themeName: ThemeName.welt_contrast,
    locale: "de_de",
  },
];

export const getBrand = (
  organizationId: string,
  categoryId?: string,
  locale?: string,
  themeName?: ThemeName
): BrandSettings => {
  const organization = organizations.find(
    (org) => org.id === organizationId.toUpperCase()
  );

  let brand = organization ?? DEFAULT_BRAND_SETTINGS;

  if (organization && categoryId) {
    const category = organization.categories?.find(
      (cat) => cat.id === categoryId.toLowerCase()
    );
    brand = category ?? organization;
  }

  // return with overwrites
  return {
    ...brand,
    ...(locale && { locale }),
    ...(themeName && { themeName }),
  };
};
